import { render } from "./_Pdf.vue?vue&type=template&id=0979529d&scoped=true"
import script from "./_Pdf.vue?vue&type=script&lang=ts"
export * from "./_Pdf.vue?vue&type=script&lang=ts"

import "./_Pdf.vue?vue&type=style&index=0&id=0979529d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0979529d"

export default script